{
  "el": {
    "task_assignment": {
      "actions": {
        "confirm": "Σήμανση ως ολοκληρωμένη",
        "create": "Εργασία",
        "move_to_draft": "Επαναφορά σε πρόχειρη",
        "reopen": "Άνοιγμα ξανά",
        "send_and_notify": "Αποστολή και ειδοποίηση"
      },
      "assignee_types": {
        "customer": "Πελάτης",
        "employee": "Υπάλληλος",
        "partner": "Συνεργάτης"
      },
      "attributes": {
        "assignee": "Υπεύθυνος",
        "assignees": "Υπεύθυνοι",
        "created_at": "Δημιουργήθηκε",
        "due_date": "Προθεσμία",
        "project": "Έργο",
        "status": "Κατάσταση",
        "task": "Εργασία",
        "unit": "Ακίνητο"
      },
      "confirm": {
        "affected": "Αυτό αφορά {customers} και {team}.",
        "affected_customers": "Αυτό αφορά {customers}.",
        "affected_team": "Αυτό αφορά {team}.",
        "complete_body": "Οι εργασίες τους κλείνουν και εξαφανίζονται από τη λίστα τους, ακόμη κι αν δεν έκαναν τίποτα.",
        "complete_header": "Κλείσιμο αυτής της εργασίας για όλους;",
        "customer_tasks": "{count} εργασία πελάτη | {count} εργασίες πελατών",
        "draft_body": "Η εργασία εξαφανίζεται μέχρι να σταλεί ξανά. Τα email που έχουν ήδη φύγει παραμένουν σταλμένα.",
        "draft_header": "Επαναφορά αυτής της εργασίας σε πρόχειρη;",
        "send_customers": "Οι πελάτες βλέπουν αμέσως την εργασία στην πύλη τους και ειδοποιούνται.",
        "send_header": "Αποστολή στους υπευθύνους;",
        "send_permanent": "Η αποστολή δεν αναιρείται. Αν επαναφέρεις αργότερα την εργασία σε πρόχειρη, η ειδοποίηση δεν παίρνεται πίσω.",
        "send_status": "Περνούν σε Ζητήθηκε.",
        "send_team": "Τα μέλη της ομάδας ειδοποιούνται.",
        "team_tasks": "{count} εργασία ομάδας | {count} εργασίες ομάδας"
      },
      "labels": {
        "add_assignee": "Προσθήκη υπευθύνου…",
        "add_customers": "Προσθήκη πελατών",
        "already_assigned": "Αυτή η εργασία έχει ήδη προστεθεί σε αυτό το ακίνητο.",
        "already_assigned_project": "Αυτή η εργασία έχει ήδη προστεθεί σε αυτό το έργο.",
        "completed": "Ολοκληρωμένη",
        "confirm_message": "Θέλεις σίγουρα να σημειώσεις αυτή την εργασία ως ολοκληρωμένη;",
        "customers": "Πελάτες",
        "my_tasks": "Οι εργασίες μου",
        "no_assignees": "Χωρίς υπευθύνους ακόμη.",
        "no_assignments": "Δεν υπάρχουν ακόμη εργασίες.",
        "no_assignments_task": "Δεν υπάρχουν ακόμη αναθέσεις για αυτή την εργασία.",
        "no_assignments_unit": "Δεν υπάρχουν ακόμη εργασίες για αυτό το ακίνητο.",
        "required": "Αυτό το πεδίο είναι υποχρεωτικό",
        "select_task": "Επίλεξε μια εργασία",
        "upload_hint": "Ανέβασε τα ζητούμενα έγγραφα για να ολοκληρώσεις αυτή την εργασία.",
        "uploaded_documents": "Ανεβασμένα έγγραφα"
      },
      "statuses": {
        "completed": "Ολοκληρωμένη",
        "draft": "Πρόχειρη",
        "requested": "Ζητήθηκε"
      },
      "toasts": {
        "completed": "Η εργασία ολοκληρώθηκε",
        "create": "Η εργασία δημιουργήθηκε",
        "delete": "Η εργασία διαγράφηκε",
        "reopened": "Η εργασία άνοιξε ξανά",
        "update": "Η εργασία ενημερώθηκε"
      }
    }
  }
}
